import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';
import { TWCText } from '@components';

import { settingsMenuTestIDs, settingsPageTestIDs, Theme } from '@constants';
import { useContextNodeHandle, useContextReference } from '@hooks';

import { styles } from './styles';

import settingsHelpQR from '../../../assets/settings_help_QR.png';
import { TWCAccessibleContent } from '../../focusable/TWCAccessibleContent/TWCAccessibleContent';

const testIDPath = settingsPageTestIDs.help;

export const SettingsHelp: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'settingsPage.help',
  });

  const helpMenuReference = useContextReference(settingsMenuTestIDs.help);
  const helpMenuHandle = useContextNodeHandle(settingsMenuTestIDs.help);

  return (
    <View style={styles.wrapper}>
      <TWCAccessibleContent
        disabledScreenreaderFocus={helpMenuReference}
        nativeID={testIDPath.settingsHelp}
        nextFocusDown={null}
        nextFocusLeft={helpMenuHandle}
        nextFocusRight={null}
        nextFocusUp={null}
        testID={testIDPath.settingsHelp}
      >
        <View style={styles.settingsHelpWrapper}>
          <TWCText style={styles.settingsHelpText} testID={testIDPath.settingsHelpIssueText} variant={'regularText36'}>
            {t('assistanceText')}
          </TWCText>
          <TWCText
            accessibilityHint={''}
            accessibilityLabel={t('assistanceAccessibleEmail')}
            style={styles.settingsHelpUrl}
            testID={testIDPath.settingsHelpIssueEmail}
            variant={'regularText42Transparent'}
          >
            {t('assistanceEmail')}
          </TWCText>
          <TWCText
            style={[styles.settingsHelpText, { marginTop: Theme.px(50) }]}
            testID={testIDPath.settingsHelpSuggestionText}
            variant={'regularText36'}
          >
            {t('feedbackText')}
          </TWCText>
          <TWCText
            accessibilityHint={''}
            accessibilityLabel={t('feedbackAccessibleEmail')}
            style={styles.settingsHelpUrl}
            testID={testIDPath.settingsHelpSuggestionEmail}
            variant={'regularText42Transparent'}
          >
            {t('feedbackEmail')}
          </TWCText>
          <TWCText
            style={[styles.settingsHelpText, { marginTop: Theme.px(50) }]}
            testID={testIDPath.settingsHelpFaqsText}
            variant={'regularText36'}
          >
            {t('faqsText')}
          </TWCText>
          <TWCText
            accessibilityHint={''}
            accessibilityLabel={t('faqsAccessibleUrl')}
            style={styles.settingsHelpUrl}
            testID={testIDPath.settingsHelpFaqsUrl}
            variant={'regularText42Transparent'}
          >
            {t('faqsUrl')}
          </TWCText>
          <Image source={settingsHelpQR} style={styles.settingsHelpQR} testID={testIDPath.settingsHelpQR} />
        </View>
      </TWCAccessibleContent>
    </View>
  );
};
